import React, { FC, useState, ReactNode } from 'react';
import classnames from 'classnames';

import { PopupGroup } from '@/scenarios/legacy-player/components/PlayerSkin/parts/PopupGroup';

import { Timeline } from '../../feature-player/ui/skin/timeline/component';
import { SeekButton } from '../../feature-player/ui/skin/seek-button/component';
import { FullScreenToggle } from '../../feature-player/ui/skin/full-screen-toggle/component';
import { BaseControlName } from '../../feature-player/types/controls';
import { VolumeControl } from '../../feature-player/ui/skin/volume-control/component';
import { VodPlayToggle } from '../../vod-player/ui/VodPlayToggle';
import { Time } from '../../feature-player/ui/skin/timeline/types/time';

import styles from './MoviePlayerControlPanel.module.css';

interface MoviePlayerControlPanelProps {
    contentId: string;
    className?: string;
    onPopupToggle?: (hasOpenedPopup: boolean) => void;
    renderTimelineCursor?: (time: Time) => ReactNode;
    renderLeftControls?: () => ReactNode;
    renderRightControls?: () => ReactNode;
}

const MoviePlayerControlPanel: FC<MoviePlayerControlPanelProps> = ({
    contentId,
    className,
    onPopupToggle,
    renderTimelineCursor,
    renderLeftControls = () => null,
    renderRightControls = () => null,
}) => {
    const [isTimelineVisible, setIsTimelineVisible] = useState(true);

    return (
        <div className={classnames(styles.root, className)}>
            <Timeline
                className={classnames(styles.timeline, { [styles.hidden]: !isTimelineVisible })}
                renderCursor={renderTimelineCursor}
            />
            <div className={styles.controls}>
                <PopupGroup onPopupToggle={onPopupToggle}>
                    <div className={styles.leftControls}>
                        <VodPlayToggle name={BaseControlName.PLAY} contentId={contentId} />
                        {renderLeftControls()}
                        <SeekButton
                            name={BaseControlName.BACKWARD}
                            type="backward"
                            contentId={contentId}
                            className={styles.backwardSeekButton}
                        />
                        <SeekButton
                            name={BaseControlName.FORWARD}
                            type="forward"
                            contentId={contentId}
                            className={styles.forwardSeekButton}
                        />
                        <VolumeControl
                            onEnlargementChanged={(isEnlarged) => setIsTimelineVisible(!isEnlarged)}
                            className={styles.volumeControl}
                        />
                    </div>
                    <div className={styles.rightControls}>
                        {renderRightControls()}
                        <FullScreenToggle name={BaseControlName.FULLSCREEN} contentId={contentId} />
                    </div>
                </PopupGroup>
            </div>
        </div>
    );
};

export default MoviePlayerControlPanel;
